// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__96Bho","large":"loader_large__HSSaS","arch":"loader_arch__vUjNZ","slide":"loader_slide__9SHN5"};